export default __webpack_public_path__ + "static/media/Vehicle-Reg-Screely.fe5806ca.png";